import React, { useState, useEffect}  from 'react';
import { get,post } from '../../util/request';
import { useHistory } from 'react-router';
import { useSelector, useDispatch } from 'react-redux';
import { userInfo, updateUserInfoFun } from '../../redux/slice';
import Table from 'react-bootstrap/Table';
import Form from 'react-bootstrap/Form';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import Button from 'react-bootstrap/Button';

import './index.scss'



const SelectRole = () => {
  console.log('role')
  const history = useHistory();
  const dispatch = useDispatch();
  const user = useSelector(userInfo);

  const [searchMasterPlanID, setSearchMasterPlanID] = useState('');

  //list data handle
  const [listData, setListData] = useState([]);
  const [pageNum, setPageNum] = useState(0);
  const [pageSize, setPageSize] = useState(50);
  const [total, setTotal] = useState(0);

  console.log(user)
  var setFormData = function (data) {
    var params = new FormData();
    for (var key in data) {
      if (data[key] !== null && data[key] !== undefined) {
        params.append(key, data[key]);
      }
    }
    return params;
  }

  const init = async ()=>{
    let params = {
      masterPlanID: searchMasterPlanID,
      pageSize: pageSize,
      pageNumber: pageNum,
      userId: user.userId,
      deviceId: null,
      deviceModel:' WEB',
      deviceToken: null,
      entry:'WEB',
      isChina: false,
      accessToken: user.accessToken,
      userId: user.userId,
    };

    const data = await get('/appProducts/', params);
    if (data) {
      setListData(data.content);
    }
    
  };
  const handleSearchName = (e) => {
    setSearchMasterPlanID(e.target.value);
  }

  useEffect(() => {
    init();
  }, []);


  return (
    <div className="col-sm-12 background">
        <div className="col-sm-8 container title">
          Products
        </div>
        <div className="col-sm-8 container searh-row">
          <div className="col-sm-5 float-left">
          <input className="form-control" type="text" placeholder="Keywords" aria-label="search input" value={searchMasterPlanID} onChange={handleSearchName}></input>
          </div>
          <div className="col-sm-2 float-left ">
            <div>
              <button type="button" class="searchBtn btn btn-outline-theme" onClick={()=>{init()}}>Search</button>
              <button type="button" class="linkBtn btn btn-link-theme " onClick={()=>{setSearchMasterPlanID('')}}>Clear</button>
            </div>
          </div>
          {/* <div className=" float-right ">
            <div className='filterSortby'>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 22" fill="none">
                <path d="M4.2116 5.61C6.2316 8.2 9.9616 13 9.9616 13V19C9.9616 19.55 10.4116 20 10.9616 20H12.9616C13.5116 20 13.9616 19.55 13.9616 19V13C13.9616 13 17.6816 8.2 19.7016 5.61C20.2116 4.95 19.7416 4 18.9116 4H5.0016C4.1716 4 3.7016 4.95 4.2116 5.61Z" fill="#003448" />
              </svg>
              <button type="button" class="linkBtn btn btn-link-theme ">Filter</button>
              <div className="fly-mid"></div>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M8.35766 16.7616H10.0979C10.1826 16.7616 10.252 16.7888 10.3064 16.843C10.3606 16.8977 10.3879 16.967 10.3879 17.052C10.3879 17.1241 10.3578 17.1969 10.2972 17.2692L7.40594 20.1606C7.34556 20.2148 7.27601 20.2419 7.19747 20.2419C7.12489 20.2419 7.05547 20.2148 6.98899 20.1606L4.08864 17.2601C3.9981 17.1634 3.97683 17.0577 4.02524 16.9428C4.07362 16.822 4.16429 16.7616 4.29712 16.7616H6.03737V4.29C6.03737 4.20549 6.06464 4.13597 6.11889 4.08152C6.17321 4.02714 6.24283 4 6.32737 4H8.06762C8.15229 4 8.22172 4.02727 8.27613 4.08156C8.33055 4.13587 8.35766 4.20549 8.35766 4.29003V16.7616ZM12.1283 6.32029H14.4485C14.5331 6.32029 14.6026 6.29314 14.6568 6.23876C14.7114 6.18435 14.7382 6.11492 14.7382 6.03029V4.29003C14.7382 4.20549 14.7113 4.13597 14.6568 4.08156C14.6026 4.02727 14.5331 4 14.4485 4H12.1283C12.0436 4 11.9742 4.02714 11.9198 4.08152C11.8655 4.13597 11.8383 4.20549 11.8383 4.29V6.03025C11.8383 6.11489 11.8654 6.18432 11.9198 6.23873C11.9742 6.29302 12.0436 6.32029 12.1283 6.32029ZM12.1282 10.961H16.1887C16.2733 10.961 16.3428 10.9338 16.397 10.8794C16.4515 10.825 16.4787 10.7556 16.4787 10.6709V8.93073C16.4787 8.84606 16.4515 8.77663 16.397 8.72225C16.3428 8.66794 16.2733 8.64067 16.1887 8.64067H12.1282C12.0435 8.64067 11.9741 8.66781 11.9197 8.72225C11.8654 8.77663 11.8382 8.84606 11.8382 8.93073V10.6709C11.8382 10.7556 11.8653 10.825 11.9197 10.8794C11.9741 10.9337 12.0435 10.961 12.1282 10.961ZM19.8777 18.0035C19.8232 17.9489 19.7538 17.9218 19.6692 17.9218H12.1283C12.0436 17.9218 11.9742 17.9489 11.9198 18.0035C11.8655 18.0578 11.8383 18.1273 11.8383 18.2118V19.952C11.8383 20.0369 11.8654 20.1061 11.9198 20.1606C11.9742 20.2149 12.0436 20.2421 12.1283 20.2421H19.6692C19.7538 20.2421 19.8232 20.2149 19.8777 20.1606C19.932 20.106 19.9591 20.0369 19.9591 19.952V18.2118C19.9592 18.1273 19.932 18.0578 19.8777 18.0035ZM17.929 15.6014H12.1282C12.0435 15.6014 11.9741 15.5743 11.9197 15.52C11.8653 15.4657 11.8382 15.3961 11.8382 15.3116V13.5712C11.8382 13.4867 11.8654 13.4172 11.9197 13.3629C11.9741 13.3085 12.0435 13.2814 12.1282 13.2814H17.929C18.0135 13.2814 18.083 13.3085 18.1376 13.3629C18.1918 13.4171 18.2189 13.4867 18.2189 13.5712V15.3116C18.2189 15.3961 18.1918 15.4657 18.1376 15.52C18.0831 15.5743 18.0135 15.6014 17.929 15.6014Z" fill="#003448" />
              </svg>
              <button type="button" class="linkBtn btn btn-link-theme ">Sort by</button>
            </div>
          </div> */}
        </div>
        <div className="col-sm-8  container table-body">
          <Tabs
            defaultActiveKey="LAND"
            id="fill-tab-example"
            className="mb-3"
            fill
          >
            <Tab eventKey="LAND" title="LAND">

            
                <div className="col-sm-12 container table-body">
                {listData.map(item=>{
                  return (
                    <div class="card mb-3" >
                      <div class="row g-0">
                        <div class="col-md-3">
                          <img src="../../../src/assets/images/logo.png" class="img-fluid rounded-start" />
                        </div>
                        <div class="col-md-8">
                        <div class="col-md-8">
                          <div class="card-body">
                            <h5 class="card-title mb-3">{item.productName}</h5>
                            <p class="card-text mb-3">{item.productName}</p>
                          
                            <p class="card-text mb-3"><small class="text-muted">{item.updateDate}</small></p>
                          </div>
                        </div>
                        </div>
                      </div>
                    </div>
                    )
                  })}
            </div>

           
          <div className='col-sm-8'>

          </div>
            </Tab>
            <Tab eventKey="LOAN" title="LOAN">
              Tab content for Profile
            </Tab>

          </Tabs>
        </div>
        

          
        
       
    </div>
  );
};
export default SelectRole;
